/**
 * Normaliza un timestamp a formato ISO string
 * @param {number|string} timestamp - Timestamp en formato Unix (segundos o milisegundos) o string
 * @returns {string} Timestamp en formato ISO string
 */
export function normalizeTimestamp(timestamp) {
  if (!timestamp) return new Date().toISOString();
  
  if (typeof timestamp === 'number') {
    // Si el número es muy grande, probablemente son milisegundos
    // Si es pequeño (menos de 1e12), probablemente son segundos
    const date = timestamp > 1e12 ? new Date(timestamp) : new Date(timestamp * 1000);
    // Validar que la fecha sea válida y razonable
    if (!isNaN(date.getTime()) && date.getFullYear() >= 1900 && date.getFullYear() <= 2100) {
      return date.toISOString();
    }
    console.warn('Invalid timestamp number:', timestamp);
    return new Date().toISOString();
  }
  
  if (typeof timestamp === 'string') {
    const date = new Date(timestamp);
    // Validar que la fecha sea válida y razonable
    if (!isNaN(date.getTime()) && date.getFullYear() >= 1900 && date.getFullYear() <= 2100) {
      return date.toISOString();
    }
    console.warn('Invalid timestamp string:', timestamp);
    return new Date().toISOString();
  }
  
  return new Date().toISOString();
}

/**
 * Formatea un timestamp para mostrar en la tabla (dd/MM/yyyy HH:mm)
 * @param {number|string} timestamp - Timestamp a formatear
 * @returns {string} Fecha formateada o "-" si es inválida
 */
export function formatDateTime(timestamp) {
  if (!timestamp) return "-";
  try {
    let date;
    
    // Si es un número, podría ser Unix timestamp (segundos o milisegundos)
    if (typeof timestamp === 'number') {
      // Si el número es muy grande, probablemente son milisegundos
      // Si es pequeño (menos de 1e12), probablemente son segundos
      date = timestamp > 1e12 
        ? new Date(timestamp) 
        : new Date(timestamp * 1000);
    } else if (typeof timestamp === 'string') {
      // Intentar parsear como ISO string o fecha estándar
      date = new Date(timestamp);
    } else {
      date = new Date(timestamp);
    }
    
    // Validar que la fecha sea válida
    if (isNaN(date.getTime())) {
      console.error('Invalid date:', timestamp);
      return "-";
    }
    
    // Validar que el año sea razonable (entre 1900 y 2100)
    const year = date.getFullYear();
    if (year < 1900 || year > 2100) {
      console.error('Date out of reasonable range:', timestamp, 'Year:', year);
      return "-";
    }
    
    return new Intl.DateTimeFormat('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  } catch (error) {
    console.error('Error formatting date:', error, 'Timestamp:', timestamp);
    return "-";
  }
}

/**
 * Formatea un rango de fechas para mostrar en el modal (dd/MM/yyyy - dd/MM/yyyy)
 * @param {Object} dateRange - Objeto con startDate y endDate
 * @returns {string} Rango de fechas formateado o "-" si es inválido
 */
export function formatDateRangeForModal(dateRange) {
  if (!dateRange || !dateRange.startDate || !dateRange.endDate) return "-";
  try {
    const startDate = new Date(dateRange.startDate);
    const endDate = new Date(dateRange.endDate);
    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };
    return `${formatDate(startDate)} - ${formatDate(endDate)}`;
  } catch (error) {
    return "-";
  }
}

